import { Component, OnInit, Renderer2, inject } from "@angular/core";

import {
  TagManagerService,
  EventService,
  ThemeService,
  KeyboardService,
  KeyCodes,
  AppointmentService,
  ChunkLoadRecoveryService,
} from "../core-ui/services";
import { LocaleService } from "./services/locale.service";
import { NavigationEnd, NavigationError, Router } from "@angular/router";
import { filter, take } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: false,
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  private appointment = inject(AppointmentService);
  private keyboard = inject(KeyboardService);
  private chunkRecovery = inject(ChunkLoadRecoveryService);

  constructor() {
    const gtmService = inject(TagManagerService);
    const eventService = inject(EventService);
    const localization = inject(LocaleService);
    const renderer = inject(Renderer2);
    const theme = inject(ThemeService);

    eventService.start();
    localization.init();

    // Google Tag Manager setup
    gtmService.trackPages();

    // cannot inject renderer to service
    theme.setRenderer(renderer);
  }

  ngOnInit() {
    this.keyboard.listen(KeyCodes.Enter, this.onEnterKey);
    this.keyboard.listen(KeyCodes.NumpadEnter, this.onEnterKey);

    // we want to run after the guards are done
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() => {
        this.appointment.listenForEndedInteractions();
      });

    // Self-heal stale lazy-chunk load failures after a new deploy: a failed
    // dynamic import surfaces as a NavigationError; reload once to pick up the
    // fresh chunk manifest. Clear the reload guard on any successful navigation.
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationError) {
        this.chunkRecovery.reloadIfChunkError(event.error);
      } else if (event instanceof NavigationEnd) {
        this.chunkRecovery.clearReloadFlag();
      }
    });
  }

  private onEnterKey = () => {
    if (
      document.activeElement &&
      document.activeElement.hasAttribute("tabindex") &&
      document.activeElement.tagName === "AV-MENU-ITEM"
    ) {
      document.activeElement.dispatchEvent(new MouseEvent("click"));
    }
  };
}
